import React from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface CtaFrameProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'forest' | 'charcoal';
}
/**
 * High-contrast framed container for CTA sections.
 * Deep green or dark charcoal background with bright golden border + glow.
 */
export function CtaFrame({
  children,
  className,
  variant = 'forest'
}: CtaFrameProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={cn('relative rounded-3xl p-6 sm:p-8 md:p-12 border-2 overflow-hidden', {
    'bg-gradient-to-br from-forest-deep via-forest to-forest-deep border-honey/70': variant === 'forest',
    'bg-gradient-to-br from-charcoal via-charcoal-light to-charcoal border-honey/70': variant === 'charcoal'
  },
  // Glow shadow
  'shadow-[0_25px_60px_-15px_rgba(0,0,0,0.4),0_0_0_1px_rgba(212,162,76,0.2),0_0_40px_-5px_rgba(212,162,76,0.25)]', className)} data-id="element-437">
      {/* Inner golden hairline frame */}
      <div className="absolute inset-2 rounded-[1.25rem] border border-honey/25 pointer-events-none" data-id="element-438" />
      {/* Corner accents */}
      <div className="absolute top-3 left-3 w-6 h-6 border-t-2 border-l-2 border-honey rounded-tl-2xl pointer-events-none" data-id="element-439" />
      <div className="absolute top-3 right-3 w-6 h-6 border-t-2 border-r-2 border-honey rounded-tr-2xl pointer-events-none" data-id="element-440" />
      <div className="absolute bottom-3 left-3 w-6 h-6 border-b-2 border-l-2 border-honey rounded-bl-2xl pointer-events-none" data-id="element-441" />
      <div className="absolute bottom-3 right-3 w-6 h-6 border-b-2 border-r-2 border-honey rounded-br-2xl pointer-events-none" data-id="element-442" />

      <div className="relative z-10" data-id="element-443">{children}</div>
    </motion.div>;
}